/**
 * Shared display formatters used across client tab components.
 *
 * These were duplicated in RankTab + LocalSEOTab; extracted here so any future tab
 * gets the same number / date / domain formatting for free.
 */

/** Pretty-print a number: 1234 → "1.2K", 1500000 → "1.5M". `null`/`undefined` → "—". */
export function fmt(n) {
  if (n == null) return "—";
  if (typeof n === "number") {
    if (n >= 1e6) return (n / 1e6).toFixed(1) + "M";
    if (n >= 1e3) return (n / 1e3).toFixed(1) + "K";
    return String(n);
  }
  return String(n);
}

/** Lowercase a domain, strip scheme + `www.` prefix + path. */
export function normDomain(s) {
  return (s || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .replace(/\/.*$/, "");
}

/** Locale long date — "07 Feb 2026". */
export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
}

/** Locale short date — "Feb 7". */
export function fmtDateShort(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
